/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Components.Controls {
    class ImageUploadController {
        static $inject = ["$mdDialog", "directiveScope"];
        public imageItem: string;
        public newImageItem: string;
        public imageUrl: string;
        public directiveScope: any;
        public imagePreview: string;
        constructor(private $mdDialog: angular.material.IDialogService, directiveScope: any) {
            this.directiveScope = directiveScope;
            this.setup();

        }
        
        setup = () => {
            this.newImageItem = this.directiveScope.imageUrl != "assets/images/photo_not_available.svg" ? this.directiveScope.imageUrl : "";
            this.imagePreview = this.directiveScope.imageUrl ? this.directiveScope.imageUrl : "assets/images/photo_not_available.svg";

        }
        apply = () => {
            this.directiveScope.imageUrl = this.newImageItem;
            this.directiveScope.apply();
        }

        cancel = () => {
            this.directiveScope.cancel();
        }

        

    }
    angular.module("meevo.components.controls")
        .controller("meevo.components.controls.ImageUploadController", ImageUploadController);
}